import type { InstantConfigRepository } from "instant-config";

import { AdEnginePlugin, type Hooks } from "../../core/AdEnginePlugin";
import { PrebidPlugin } from "./PrebidPlugin";
import { globalS2sConfig } from "../../config/platforms/shared/bidders/prebid/server-to-server/global-s2s-config";
import { magniteS2sConfig } from "../../config/platforms/shared/bidders/prebid/server-to-server/magnite-s2s-config";

export class ServerToServerPlugin extends AdEnginePlugin {
  constructor(private readonly config: Partial<InstantConfigRepository> = {}) {
    super();
  }

  static isEnabled(config: Partial<InstantConfigRepository>): boolean {
    return Boolean(config?.icPrebidMagniteS2s);
  }

  hooks: Hooks = {
    onBiddersInit: () => {
      // we can modify the config here dynamically in future when we decide to add more s2s bidders
      if (this.config.icPrebidMagniteS2s) {
        const prebidPlugin = this.usePlugin(PrebidPlugin);
        prebidPlugin?.addPrebidReadyCallback((pbjs: Prebid) => {
          pbjs.setConfig(globalS2sConfig);
        });

        prebidPlugin?.addPrebidReadyCallback((pbjs: Prebid) => {
          pbjs.mergeConfig({
            s2sConfig: [magniteS2sConfig],
          });
        });
      }
    },
  };
}
